import { FormLabelUI, AutoCompleteSelectUI, DatePickerUI } from '../Interface';

const AttendanceSettlementFields = ({ viewField, values, selectedValues, autocompleteOptions }) => {
  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-4 mx-2 mb-5">
      <div className="col-span-4 md:col-span-1">
        <DatePickerUI label={<FormLabelUI text="Dátum" />} value={values.createdAt} disabled={viewField} />
      </div>
      <div className="col-span-4 md:col-span-2">
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Projekt" />}
          selectedValue={values.projectId}
          selectedLabelValue={selectedValues?.project?.projectName}
          dataset={autocompleteOptions.project}
          disabled={viewField}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Cég" />}
          selectedValue={values.companyId}
          selectedLabelValue={selectedValues?.company?.name}
          dataset={autocompleteOptions.company}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default AttendanceSettlementFields;
